import { render, staticRenderFns } from "./VPIScore.vue?vue&type=template&id=90d6960c&scoped=true&"
import script from "./VPIScore.vue?vue&type=script&lang=js&"
export * from "./VPIScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d6960c",
  null
  
)

export default component.exports